import noop from 'lodash/fp/noop';

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import { ALL, deviceStatusNameOptions, deviceStatusTypeOptions } from '~/features/base/constants/filterOptions';
import Select from '@rio-cloud/rio-uikit/lib/es/Select';

const DEVICE_STATUS_NAME_PROD_MODE = 'prod_mode';

export class DeviceStatusFormItem extends Component {

    onDeviceStatusNamesChange = (item) => {
        if (item.value === DEVICE_STATUS_NAME_PROD_MODE) {
            this.props.onDeviceStatusNamesChange({
                deviceStatusNames: undefined,
                productionMode: true,
            });
        } else {
            this.props.onDeviceStatusNamesChange({
                deviceStatusNames: item.id === ALL ? undefined : item.value,
                productionMode: undefined,
            });
        }
    };

    onDeviceStatusTypeChange = (item) => {
        this.props.onDeviceStatusTypeChange({
            deviceStatusType: item.id === ALL ? undefined : item.value,
        });
    };

    render() {
        const {
            labelDeviceStatusNames,
            labelDeviceStatusTypes,
            valueDeviceStatusNames,
            valueDeviceStatusTypes,
            productionMode,
        } = this.props;

        const nameOptionsWithSelection = deviceStatusNameOptions.map(option => ({
            ...option,
            selected: productionMode === true ? option.value === DEVICE_STATUS_NAME_PROD_MODE :
                                              option.value === valueDeviceStatusNames,
        }));

        const typeOptionsWithSelection = deviceStatusTypeOptions.map(option => ({
            ...option,
            selected: option.value === (valueDeviceStatusTypes || ALL),
        }));
        return (
            <div className='form-group'>
                <div className='row'>
                    <div className='form-group col-md-6'>
                        <label className='control-label'>
                            <FormattedMessage id={labelDeviceStatusNames}/>
                        </label>
                        <Select options={nameOptionsWithSelection}
                                onChange={this.onDeviceStatusNamesChange}/>
                    </div>
                    <div className='form-group col-md-6'>
                        <label className='control-label'>
                            <FormattedMessage id={labelDeviceStatusTypes}/>
                        </label>
                        <Select options={typeOptionsWithSelection}
                                onChange={this.onDeviceStatusTypeChange}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeviceStatusFormItem;

DeviceStatusFormItem.defaultProps = {
    // props
    labelDeviceStatusNames: 'intl-msg:deviceStatus',
    labelDeviceStatusTypes: 'intl-msg:deviceHealthTypes',
    valueDeviceStatusNames: ALL,
    valueDeviceStatusTypes: ALL,
    deviceStatusNames: [],
    deviceStatusTypes: [],
    // functions
    onDeviceStatusNamesChange: noop,
    onDeviceStatusTypeChange: noop,
};

DeviceStatusFormItem.propTypes = {
    // props
    labelDeviceStatusNames: PropTypes.string,
    labelDeviceStatusTypes: PropTypes.string,
    valueDeviceStatusNames: PropTypes.string,
    valueDeviceStatusTypes: PropTypes.string,
    deviceStatusNames: PropTypes.array,
    deviceStatusTypes: PropTypes.array,
    productionMode: PropTypes.bool,
    // functions
    onDeviceStatusNamesChange: PropTypes.func,
    onDeviceStatusTypeChange: PropTypes.func,
};
